import { useState, useEffect } from 'react'
import { Box, Typography, useMediaQuery, useTheme, Snackbar, Alert } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import MyBasicInfo from './components/MyBasicInfo'
import MyProfileDetails from './components/MyProfileDetails'
import { SIDE_PANEL_WIDTH } from '@/utils/constants'
import { CBox, Page, RBox } from '../__styled'
import PageWrapper from '@/components/PageWrapper'

export default function MyProfile() {
  const theme = useTheme()
  const lessThanLarge = useMediaQuery(theme.breakpoints.down('lg'))
  const [searchParams, setSearchParams] = useSearchParams()
  const [checkoutSnackbar, setCheckoutSnackbar] = useState<{ open: boolean; message: string; severity: 'success' | 'info' }>({
    open: false, message: '', severity: 'success',
  })

  useEffect(() => {
    const checkout = searchParams.get('checkout')
    if (checkout === 'success') {
      setCheckoutSnackbar({ open: true, message: "You're now subscribed! Your plan is active.", severity: 'success' })
      setSearchParams({}, { replace: true })
    } else if (checkout === 'cancel') {
      setCheckoutSnackbar({ open: true, message: 'Checkout was cancelled — no charge was made.', severity: 'info' })
      setSearchParams({}, { replace: true })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const snackbar = (
    <Snackbar
      open={checkoutSnackbar.open}
      autoHideDuration={6000}
      onClose={() => setCheckoutSnackbar(s => ({ ...s, open: false }))}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={() => setCheckoutSnackbar(s => ({ ...s, open: false }))} severity={checkoutSnackbar.severity} sx={{ width: '100%' }}>
        {checkoutSnackbar.message}
      </Alert>
    </Snackbar>
  )

  if (lessThanLarge) {
    return (
      <PageWrapper
        title='My Profile'
        sx={{
          display: 'flex',
          width: '100%',
          overflow: 'auto',
          flex: 1,
        }}
      >
        <CBox gap={'24px'}>
          <MyBasicInfo />
          <MyProfileDetails />
        </CBox>
        {snackbar}
      </PageWrapper>
    )
  }
  return (
    <PageWrapper
      title='My Profile'
      sx={{
        display: 'flex',
        width: '100%',
        overflow: 'auto',
        flexDirection: 'row',
        flex: 1,
      }}
    >
      <Box width='380px' height='100%' overflow='auto' flexShrink={0}>
        <MyBasicInfo />
      </Box>
      <Box sx={{ flex: 1, overflow: 'auto', px: '32px', pb: '32px', pt: 0.5, maxWidth: '1200px' }}>
        <MyProfileDetails />
      </Box>
      {snackbar}
    </PageWrapper>
  )
}
